const NewTimeline = ({
    states,
    newOrigin,
    setActivePhase,
    getPdfLinkNewOrigin,
    getStateText,
    getPhaseStatus,
    getSecondOriginPhaseIcon,
    getSecondOriginProgress,
    getNewOriginPhaseStatus,
    setSelectedOrigin,
}) => {
    return (
        <>
            <tr>
                <td className="first-block-spacer"></td>
                {states.map(state => (
                    <td className="even-box" key={`${state.id}-new`}>
                        <div className={`text-center phase-box mx-auto`}>
                            <div className="mt-4">
                                <a href={getPdfLinkNewOrigin(state.id)} target="_blank" className="mb-0 project-pdf">
                                    <img src="./assets/images/pdf-svgrepo-com.svg" width={24} />
                                    <br/>
                                    Análisis texto
                                </a>
                            </div>
                        </div>
                    </td>
                ))}
            </tr>

            <tr>
                <td className="first-block-spacer">
                    <div className="d-flex gap-2 p-2 align-items-center justify-content-end">
                        <span className="origin-name">&nbsp;&nbsp;{ newOrigin.origin }</span>
                    </div>
                </td>
                <td colSpan={4}>
                    <div className="gap-2 p-2 align-items-center mobile-origin">
                        <span className="origin-name">{ newOrigin.origin }</span>
                    </div>

                    <div className="progress-visual p-2 timeline-progress">
                        <div className="progress mt-0 bg-white">
                            <div className="progress-bar bg-bluegreen" role="progressbar" style={{width: getSecondOriginProgress()}} aria-valuenow={getSecondOriginProgress()} aria-valuemin="0" aria-valuemax="100"></div>                                
                        </div>
                        
                        <img
                            src={getSecondOriginPhaseIcon(1)}
                            width={21}
                            className="timeline-tick timeline-phase1"
                            onClick={() => {
                                if (getNewOriginPhaseStatus(1) == 'na') {
                                    return;
                                }

                                setSelectedOrigin(2)
                                setActivePhase(1);
                            }}
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-html="true"
                            data-bs-content={`<span className='project-pop'>${getPhaseStatus(5) == 'finished' || getPhaseStatus(5) == 'ongoing' ? getStateText(5) : 'El proyecto aún no ha pasado por está fase'}</span>`}
                        />
                        <img
                            src={getSecondOriginPhaseIcon(2)}
                            width={21}
                            className="timeline-tick timeline-phase2"
                            onClick={() => {
                                if (getNewOriginPhaseStatus(2) == 'na') {
                                    return;
                                }

                                setSelectedOrigin(2)
                                setActivePhase(2);
                            }}
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-html="true"
                            data-bs-content={`<span className='project-pop'>${getPhaseStatus(6) == 'finished' || getPhaseStatus(6) == 'ongoing' ? getStateText(6) : 'El proyecto aún no ha pasado por está fase'}</span>`}
                        />
                        <img
                            src={getSecondOriginPhaseIcon(3)}
                            width={21}
                            className="timeline-tick timeline-phase3"
                            onClick={() => {
                                if (getNewOriginPhaseStatus(3) == 'na') {
                                    return;
                                }

                                setSelectedOrigin(2)
                                setActivePhase(3);
                            }}
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-html="true"
                            data-bs-content={`<span className='project-pop'>${getPhaseStatus(7) == 'finished' || getPhaseStatus(7) == 'ongoing' ? getStateText(7) : 'El proyecto aún no ha pasado por está fase'}</span>`}
                        />
                        <img
                            src={getSecondOriginPhaseIcon(4)}
                            width={21}
                            className="timeline-tick timeline-phase4"
                            onClick={() => {
                                if (getNewOriginPhaseStatus(4) == 'na') {
                                    return;
                                }

                                setSelectedOrigin(2)
                                setActivePhase(4);
                            }}
                            data-bs-toggle="popover"
                            data-bs-placement="top"
                            data-bs-trigger="hover"
                            data-bs-html="true"
                            data-bs-content={`<span className='project-pop'>${getPhaseStatus(8) == 'finished' || getPhaseStatus(8) == 'ongoing' ? getStateText(8) : 'El proyecto aún no ha pasado por está fase'}</span>`}
                        />
                    </div>
                </td>
            </tr>
        </>
    );
}

export default NewTimeline;